import {
  authenticatedApi,
  ApiError,
  API_BASE_URL,
} from './apiUtils';

export const placementActivityApi = {

  // ── Placement Activity Types ──────────────────────────────────────────────

  getAllActivityTypes: async () => {
    try {
      return await authenticatedApi.get(`${API_BASE_URL}/placement-activity-types`);
    } catch (error) {
      throw new ApiError('Failed to fetch placement activity types', error.status || 500);
    }
  },

  createActivityType: async (data) => {
    try {
      return await authenticatedApi.post(`${API_BASE_URL}/placement-activity-types`, data);
    } catch (error) {
      if (error.status === 400) {
        throw new ApiError(error.data?.error || 'Invalid placement activity type data', 400);
      }
      throw new ApiError('Failed to create placement activity type', error.status || 500);
    }
  },

  updateActivityType: async (id, data) => {
    try {
      return await authenticatedApi.put(`${API_BASE_URL}/placement-activity-types/${id}`, data);
    } catch (error) {
      if (error.status === 400) {
        throw new ApiError(error.data?.error || 'Invalid placement activity type data', 400);
      }
      if (error.status === 404) {
        throw new ApiError('Placement activity type not found', 404);
      }
      throw new ApiError('Failed to update placement activity type', error.status || 500);
    }
  },

  deleteActivityType: async (id) => {
    try {
      return await authenticatedApi.delete(`${API_BASE_URL}/placement-activity-types/${id}`);
    } catch (error) {
      if (error.status === 404) {
        throw new ApiError('Placement activity type not found', 404);
      }
      if (error.status === 400) {
        throw new ApiError(error.data?.error || 'Cannot delete this placement activity type', 400);
      }
      throw new ApiError('Failed to delete placement activity type', error.status || 500);
    }
  },

  // ── Placement Status Types ────────────────────────────────────────────────

  getAllStatusTypes: async () => {
    try {
      return await authenticatedApi.get(`${API_BASE_URL}/placement-status-types`);
    } catch (error) {
      throw new ApiError('Failed to fetch placement status types', error.status || 500);
    }
  },

  createStatusType: async (data) => {
    try {
      return await authenticatedApi.post(`${API_BASE_URL}/placement-status-types`, data);
    } catch (error) {
      if (error.status === 400) {
        throw new ApiError(error.data?.error || 'Invalid placement status type data', 400);
      }
      throw new ApiError('Failed to create placement status type', error.status || 500);
    }
  },

  updateStatusType: async (id, data) => {
    try {
      return await authenticatedApi.put(`${API_BASE_URL}/placement-status-types/${id}`, data);
    } catch (error) {
      if (error.status === 400) {
        throw new ApiError(error.data?.error || 'Invalid placement status type data', 400);
      }
      if (error.status === 404) {
        throw new ApiError('Placement status type not found', 404);
      }
      throw new ApiError('Failed to update placement status type', error.status || 500);
    }
  },

  deleteStatusType: async (id) => {
    try {
      return await authenticatedApi.delete(`${API_BASE_URL}/placement-status-types/${id}`);
    } catch (error) {
      if (error.status === 404) {
        throw new ApiError('Placement status type not found', 404);
      }
      if (error.status === 400) {
        throw new ApiError(error.data?.error || 'Cannot delete this placement status type', 400);
      }
      throw new ApiError('Failed to delete placement status type', error.status || 500);
    }
  },

  // ── Employee Placement Activities ─────────────────────────────────────────

  getActivitiesForEmployee: async (employeeId) => {
    try {
      return await authenticatedApi.get(`${API_BASE_URL}/employees/${employeeId}/placement-activities`);
    } catch (error) {
      throw new ApiError('Failed to fetch placement activities', error.status || 500);
    }
  },

  /**
   * Fetches the currently active FT project for an employee.
   * Returns null (via 404) if no FT project is found.
   */
  getActiveFTProject: async (employeeId) => {
    try {
      return await authenticatedApi.get(`${API_BASE_URL}/employees/${employeeId}/placement-activities/active-ft-project`);
    } catch (error) {
      if (error.status === 404) {
        return null;
      }
      throw new ApiError('Failed to fetch active FT project', error.status || 500);
    }
  },

  createActivity: async (employeeId, data) => {
    try {
      return await authenticatedApi.post(`${API_BASE_URL}/employees/${employeeId}/placement-activities`, data);
    } catch (error) {
      if (error.status === 422) {
        throw new ApiError(error.data?.error || 'No active Full-Time project found for this individual', 422);
      }
      if (error.status === 400) {
        throw new ApiError(error.data?.error || 'Invalid placement activity data', 400);
      }
      throw new ApiError('Failed to create placement activity', error.status || 500);
    }
  },

  updateActivity: async (id, data) => {
    try {
      return await authenticatedApi.put(`${API_BASE_URL}/placement-activities/${id}`, data);
    } catch (error) {
      if (error.status === 404) {
        throw new ApiError('Placement activity not found', 404);
      }
      if (error.status === 400) {
        throw new ApiError(error.data?.error || 'Invalid placement activity data', 400);
      }
      throw new ApiError('Failed to update placement activity', error.status || 500);
    }
  },

  deleteActivity: async (id) => {
    try {
      return await authenticatedApi.delete(`${API_BASE_URL}/placement-activities/${id}`);
    } catch (error) {
      if (error.status === 404) {
        throw new ApiError('Placement activity not found', 404);
      }
      throw new ApiError('Failed to delete placement activity', error.status || 500);
    }
  },
};
